import {useEffect, useState} from 'react'
import {fetchMaterialGroups} from '../services/fetcher'

/**
 * Hook yang digunakan untuk mendapatkan data material groups
 */
export const useMaterialGroups = () => {
  const [options, setOptions] = useState<{label: string; value: string}[]>([])

  const fethcer = async () => {
    const res = await fetchMaterialGroups()
    setOptions(
      res.data.data.map((item: {material_group_desc: string; material_group: string}) => ({
        label: item.material_group_desc,
        value: item.material_group,
      }))
    )
  }
  useEffect(() => {
    fethcer()
  }, [])

  return {options}
}
